import React from 'react';
import { elements } from '@ecosystem/newron-design-system';
import PeriodDisplay from '../period-display/PeriodDisplay';

import * as styles from './TimeFrameDisplay.module.scss';
import { BaseTimePeriod } from '@services/FiltersTypes';

const { Icon } = elements;
const { Calendar, ChevronDown } = Icon.icons;

export type TimeFrameDisplayProps = {
  isPeriodSelected: boolean;
  earliestPeriod: BaseTimePeriod;
  latestPeriod: BaseTimePeriod;
  isDisplayNoComparisonLabel: boolean;
};

const TimeFrameDisplay: React.FC<TimeFrameDisplayProps> = ({
  isPeriodSelected,
  earliestPeriod,
  latestPeriod,
  isDisplayNoComparisonLabel,
}) => {
  const renderPeriodDisplay = () => {
    if (isDisplayNoComparisonLabel) {
      const noComparison: BaseTimePeriod = {
        label: 'No Comparison',
        value: 'No Comparison',
        lastUpdatedDate: 0,
      };
      return <PeriodDisplay earliestPeriod={noComparison} latestPeriod={latestPeriod} />;
    }

    if (isPeriodSelected) {
      return <PeriodDisplay earliestPeriod={earliestPeriod} latestPeriod={latestPeriod} />;
    }

    return <GenericPeriodDisplay text={'No Options'} />;
  };

  return (
    <>
      <div className={styles.TimeFrameDisplay}>
        <Icon testId={'left-icon'} size={'md'} color={'secondaryInteractive'}>
          <Calendar />
        </Icon>
        <div className={styles.TimeFrameDisplay__Field} data-testid="periodDisplay">
          {renderPeriodDisplay()}
        </div>
      </div>
      <Icon testId={'right-icon'} color={'secondaryInteractive'}>
        <ChevronDown />
      </Icon>
    </>
  );
};

const GenericPeriodDisplay: React.FC<{ text: string }> = ({ text }) => {
  return <span className={styles.PeriodDisplay}>{text}</span>;
};

export default TimeFrameDisplay;
